import { graphql } from '../__generated__/gql';

export const GET_ALL_LEAK_TEST_PACKS = graphql(/* GraphQL */ `
  query LeakTestPacks($assetId: Int!) {
    allLeakTestPacks(assetId: $assetId) {
      leakTestPackId
      assetId
      leakTestPackTitle
      leakTestPackType
      trackPackNumber
      systemNumber
      spa
      opsReview
      engineeringReview
      assetReview
      status
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
        eventId
      }
    }
  }
`);
export const GET_JOB_LEAK_TEST_PACK = graphql(/* GraphQL */ `
  query JobLeakTestPacks($jobId: Int!) {
    leakTestPacksByJobId(jobId: $jobId) {
      leakTestPackId
      assetId
      leakTestPackTitle
      leakTestPackType
      trackPackNumber
      systemNumber
      spa
      opsReview
      engineeringReview
      assetReview
      status
      comments
      updatedBy
      updatedAt
      tarJobs {
        jobId
      }
    }
  }
`);
export const CREATE_LEAK_TEST_PACK = graphql(/* GraphQL */ `
  mutation CreateLeakTestPack($input: LeakTestPackInput!) {
    createLeakTestPack(input: $input) {
      leakTestPackId
    }
  }
`);

export const UPDATE_LEAK_TEST_PACK = graphql(/* GraphQL */ `
  mutation UpdateLeakTestPack($input: LeakTestPackInput!) {
    updateLeakTestPack(input: $input) {
      leakTestPackId
    }
  }
`);

export const LINK_LEAK_TEST_PACK_JOBS = graphql(/* GraphQL */ `
  mutation LinkLeakTestPackJobs($leakTestPackId: Int!, $jobIds: [Int]!) {
    linkLeakTestPackJobs(leakTestPackId: $leakTestPackId, jobIds: $jobIds) {
      leakTestPackId
    }
  }
`);

export const REMOVE_LEAK_TEST_PACK = graphql(/* GraphQL */ `
  mutation RemoveLeakTestPack($leakTestPackId: Int!) {
    removeLeakTestPack(leakTestPackId: $leakTestPackId)
  }
`);
